<template>
  <div class="hosting-accounts-list-wrapper">
    <div class="hosting-accounts-table" v-if="hostingAccounts.length > 0">
      <table id="datatable" class="table table-striped table-bordered" cellspacing="0" width="100%">
        <thead>
          <tr>
            <th>Domain &amp; Plan Name</th>
            <th class="text-center">Status</th>
            <th class="disabled-sorting disabled-searching text-center">Setup Request</th>
<!--            <th class="disabled-sorting disabled-searching text-center">More Options</th>-->
            <th class="disabled-sorting disabled-searching text-center">View Details</th>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <th>Domain Name</th>
            <th class="text-center">Status</th>
            <th class="disabled-sorting disabled-searching text-center">Setup Request</th>
<!--            <th class="disabled-sorting disabled-searching text-center">More Options</th>-->
            <th class="disabled-sorting disabled-searching text-center">View Details</th>
          </tr>
        </tfoot>
        <tbody>
          <tr v-for="(account, index) in hostingAccounts" :key="index" v-if="!account.deleted">
            <td>
              <router-link v-if="account.status === 'pending' && adminDtls" tag="a" :class="{ 'disabled' : account.status === 'pending' }" :to="{ name: 'viewDetails', params: { index: encryptIndex( index.toString() ) } }">
                <strong>
                    <em>{{ account.domain }}</em>
                </strong>
              </router-link>
              <router-link v-else-if="account.status === 'active'" tag="a" :class="{ 'disabled' : account.status === 'pending' }" :to="{ name: 'viewDetails', params: { index: encryptIndex( index.toString() ) } }">
                <strong>
                  <em>{{ account.domain }}</em>
                </strong>
              </router-link>
              <a v-else :class="{ 'disabled' : account.status === 'pending' }">
                <strong data-toggle="tooltip" data-placement="top" title="We are working on this domain.">
                  <em>{{ account.domain }}</em>
                </strong>
              </a>

              <br> {{ account.planName }}
              <span class="badge ml-1 border-0" style="vertical-align: inherit; cursor: pointer;" :class="{ 'badge-blue': (account.type === 'Primary Domain'), 'badge-warning text-dark': (account.type === 'Addon Domain') }" data-toggle="tooltip" data-placement="top" :title="( account.type === 'Primary Domain' ? account.type : `${account.type} of ${account.addonPrimaryDomain}` )">
                {{ ( account.type === "Primary Domain" ? "Primary" : "Addon" ) }}
              </span>
              <span class="badge badge-sky ml-1 border-0" style="vertical-align: inherit; cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Staging site details are available for this domain" v-if="account.staging.enabled">Staging &nbsp; <i class="fa fa-check"></i></span>
            </td>
            <td>
              <span class="badge center" :class="{ 'badge-success': (account.status === 'active'), 'badge-danger': (account.status === 'pending') }">{{ account.status }}</span>
            </td>
            <td>
              <router-link tag="a" class="btn bg-orange btn-sm edit d-block center mb-2" :to="{ name: 'requestMigration', params: { pIndex: account.planIndex } }">
                Migration Request
              </router-link>
              <a href="#" class="btn btn-info btn-sm d-block center freash-wp-install" :disabled="(account.type === 'Primary Domain' && account.status === 'pending') || freshWordPressDisable" :data-plan="(account.type === 'Primary Domain') ? `${account.planName} - ${account.domain}` : `${account.planName} - ${account.addonPrimaryDomain}`" :data-domain="index">
                New WordPress Install
              </a>
            </td>
<!--            <td>-->
<!--              <div class="dropdown">-->
<!--                <button class="btn btn-secondary btn-sm dropdown-toggle center" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="account.comparisonID === '' && account.staging.enabled">-->
<!--                  More Options-->
<!--                </button>-->
<!--                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(55px, 26px, 0px);">-->
<!--                  <a class="dropdown-item req-staging-dtls" href="#" v-if="account.staging.enabled === false" :data-domain="account.domain">-->
<!--                    Request Staging Details-->
<!--                  </a>-->
<!--                  <div class="dropdown-divider" v-if="account.staging.enabled === false && account.comparisonID !== ''"></div>-->
<!--                  <a class="dropdown-item" :href="`https://www.bigscoots.com/comparison/show?comparision_id=${account.comparisonID}`" target="_blank" v-if="account.comparisonID !== ''">-->
<!--                    Checkout Speed Comparison-->
<!--                  </a>-->
<!--                </div>-->
<!--              </div>-->
<!--            </td>-->
            <td>
              <router-link tag="a" class="btn btn-primary btn-sm center mb-2" :class="{ 'disabled' : account.status === 'pending' }" :to="{ name: 'viewDetails', params: { index: encryptIndex( index.toString() ) } }">
                View Details
              </router-link>
              <button class="btn btn-danger btn-sm center" :disabled="removeLoading[index]" v-on:click="removeDomain(index)" v-if="account.type !== 'Primary Domain' ">
                    <div class="loader small_loader" v-if="removeLoading[index]"></div>
                    <span v-else>Remove</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
import AES from 'crypto-js/aes';
import swal from 'sweetalert2';
import {db} from "@/firebase/init";
import { functions } from '@/firebase/init';
import adminLogs from "../../../mixins/adminLogs";
const validate = require('ip-validator');

export default {
  name: "SiteList",
  mixins: [adminLogs],
  data() {
    return {
      removeLoading: [],
      adminDtls: JSON.parse(localStorage.getItem('adminDtls'))
    }
  },
  computed: {
    clientID() {
      return this.$store.getters.getCustomerID;
    },
    hostingAccounts() {
      return this.$store.getters["hosting/accountsOrdered"];
    },
    aesSecret() {
      return this.$store.getters["crypto/aesSecret"];
    },
    userToken() {
      return this.$store.getters.getUserToken;
    },
    user() {
      return this.$store.getters.user;
    },
    freshWordPressDisable() {
      return this.$store.state.freshWordPressDisable;
    },
  },
  methods: {
    removeDomain(index){
      let account = this.hostingAccounts[index];
      console.log(account);
      // First confirm the user if he truly wants to delete this domain
      swal({
        title: "Are you sure?",
        text: `Please confirm that you would like to remove  ${account.domain} domain permanently.`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
          .then(async result => {
            // Check if the user has clicked YES
            if(result.value) {
              this.removeLoading[index] = true;
              this.$set(this.removeLoading, index, true);
              if(!validate.ipv4(account.ftp.host) || !account.domain) {
                console.log('Removing locally');
                await this.removeDomainLocally(account.planIndex, account.addonIndex);
                await this.addLog({
                  primaryPlan: account.addonPrimaryDomain,
                  message: `User has removed the Domain: ${account.domain} locally`,
                  level: "info"
                })
                this.$notify({
                  group: 'foo',
                  title: 'Domain Removal',
                  duration: 3000,
                  text: 'Domain has been removed from the plan',
                  type:  'info'
                });
                this.removeLoading[index] = false;
                this.$set(this.removeLoading, index, false);
                return;
              }
              this.addLog({
                primaryPlan: account.addonPrimaryDomain,
                message: "User has tried to remove the Domain:" + account.domain,
                level: "info"
              })
              this.$http.post('domain/remove_domain', {
                domain: account.domain,
                ip: account.ftp.host,
                UID:this.user.uid,
                clientId: this.clientID,
                primaryIndex: account.planIndex,
                addonIndex: account.addonIndex,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                statusCakeTestId: account.statusCakeTestId,
                frontTableIndex: index,
                isAdmin: false,
                grant_type: "token",
              }).then(async res => {
                this.addLog({
                  primaryPlan: account.addonPrimaryDomain,
                  message: "remove-domain job has been successfully enqueued, Domain:" + account.domain,
                  level: "success"
                })
                await this.updateDomainForRemoval(account.domain);
                this.$notify({
                  group: 'foo',
                  title: 'Domain Removal',
                  duration: 3000,
                  text: res.data.msg,
                  type:  'info'
                });
              }).catch(() =>{
                this.addLog({
                  primaryPlan: account.addonPrimaryDomain,
                  message: "Error in enqueuing remove domain job, Domain:" + account.domain,
                  level: "error"
                })
                swal({
                  title: "Something went wrong!",
                  text: 'Please contact support',
                  type: "error",
                });
              }).finally(() => {
                this.removeLoading[index] = false;
                this.$set(this.removeLoading, index, false);
              })
            }
          })
    },
    async updateDomainForRemoval(domain) {
      const hostingAccountRef = await db.collection('hostingAccounts').doc(this.user.uid).get();
      const { accounts } = hostingAccountRef.data();
      const beforePayload = JSON.parse(JSON.stringify(accounts))
      accounts.map((account) => {
        const { addon } = account;
        addon.map((item) => {
          if (item.domain === domain) {
            item.deleted = true;
          }
        });
      });
      await this.addHostingAccountEventLog({hostingAccountId : this.user.uid ,  afterPayload: accounts , beforePayload : beforePayload,  action: 'Update Domain for removal'})
      await db.collection('hostingAccounts').doc(this.user.uid).update({
        accounts,
      });
    },
    async removeDomainLocally (primaryIndex, addOnIndex) {
      const hostingAccountRef = await db.collection('hostingAccounts').doc(this.user.uid).get();
      const { accounts } = hostingAccountRef.data();
      const beforePayload = JSON.parse(JSON.stringify(accounts))
      const domain = accounts[parseInt(primaryIndex)].addon[parseInt(addOnIndex)].domain
      accounts[parseInt(primaryIndex)].addon.splice(parseInt(addOnIndex), 1);
      await this.addHostingAccountEventLog({hostingAccountId : this.user.uid ,  afterPayload: accounts , beforePayload: beforePayload, action: 'Remove Domain Locally'})
      await db.collection('hostingAccounts').doc(this.user.uid).update({
        accounts,
      });
      this.addLog({
        primaryPlan: accounts[parseInt(primaryIndex)].primary.domain,
        message: domain + " domain has been removed locally",
        level: "success"
      })
    },
    encryptIndex(index) {
      return AES.encrypt(index, this.aesSecret).toString()
    },
    freashWPInstallationReq(account) {
      console.log(account);
      let self = this;
      let type = '';
      let plan='';
      if(account.type === 'Primary Domain'){
        type = 'primary';
        plan = account.planName + ' - ' + account.domain;
      }else{
        type = 'addon';
        plan = account.planName + ' - ' + account.addonPrimaryDomain;
      }
      // First confirm the user if he truly wants to request freash install for this domain
      swal({
        title: "Are you sure?",
        text:
        `Please confirm that you would like a fresh managed WordPress install for your domain ${account.domain} under the ${plan} plan. Please understand that if there is any pre-existing data on this domain, it will be overwritten.`,
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
      .then(async result => {
        // Check if the user has clicked YES
        if(result.value) {
          this.$store.commit('updateFreshWordPressDisable', true);
          this.addLog({
            primaryPlan: account.addonPrimaryDomain,
            message: `User has requested for "Fresh managed WordPress install" for ${account.domain}.`,
            level: "info"
          })
          this.$http.post('domain/fresh_wordpress', {
            grant_type: "token",
            ip: account.ftp.host,
            type: type,
            primary_index: account.planIndex,
            addon_index: account.addonIndex,
            domain: account.domain,
            planName: account.planName,
            uid:self.user.uid,
            clientID:self.user.customerID,
            firstName: this.user.firstName,
            lastName: this.user.lastName
          }).then(()=>{
            this.addLog({
              primaryPlan: account.addonPrimaryDomain,
              message: `Fresh managed WordPress install job has been enqueued, Domain: ${account.domain}`,
              level: "success"
            })
            swal({
              title: "Request Received",
              text: 'We are currently installing new wordpress on your requested domain! We will notify you once we are completed with install.',
              type: "success",
            });
          }).catch((err) =>{
            this.addLog({
              primaryPlan: account.addonPrimaryDomain,
              message: `Error in enqueuing job for fresh managed WordPress install, Domain: ${account.domain}`,
              level: "error"
            })
            console.error(err);
            this.$store.commit('updateFreshWordPressDisable', false);
            swal({
              title: "Something went wrong!",
              text: 'Please contact support!',
              type: "error",
            });
          });
        }
      })
    },
    reqStagingDetails(domain) {
      swal({
        type: "success",
        title: 'Staging site has been requested!',
        text: "You will be alerted via email once completed.",
      })
      .then(result => {
        if(result.value) {
          // set asyncDone to false
          this.$store.dispatch("async/stateUpdate", { state: false, text: 'Generating support ticket for staging request...' })
          this.addLog({
            message: `Staging site has been requested, Domain: ${domain}`,
            level: "info"
          })
          const staggingRequest = functions.httpsCallable("staggingRequest")
          staggingRequest({
            clientID: this.clientID,
            domain: domain
          })
          .then(response => {
            this.$store.dispatch("async/stateUpdate", { state: true, text: '' })
            this.addLog({
              primaryPlan: 'Account Based Operation',
              message: `Staging site job has been enqueued, Domain: ${domain}`,
              level: "success"
            })
            if(response.data.success) {
              swal({
                title: "Request Sent!",
                text: response.data.message,
                type: "success",
                confirmButtonText: "OK",
                confirmButtonColor: "#6ACF98"
              })
            } else {
              swal({
                title: "Something went wrong!",
                text: response.data.message,
                type: "error",
                confirmButtonText: "Try Again!",
                confirmButtonColor: "#EE8057"
              })
            }
          })
          .catch(err => {
            this.$store.dispatch("async/stateUpdate", { state: true })
              this.addLog({
                  message: "Error in enqueuing staging request. Domain:" + domain,
                  level:  "error"
              });

            swal({
              title: "Something went wrong!",
              text: err.message,
              type: "error",
              confirmButtonText: "Try Again!",
              confirmButtonColor: "#EE8057"
            })
          })
        }
      })
    },
	loadDataTable() {
		const freashWPIns = this.freashWPInstallationReq;
		const reqStaging = this.addStagingDnsRecord;
		let self = this;
		/* eslint-disable */
		$(document).ready(function() {
			if ( ! $.fn.DataTable.isDataTable( '#datatable' ) ) {
				$("#datatable").DataTable({
					pagingType: "simple_numbers",
					lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
					responsive: true,
          retrieve: true,
					order: [[0, "asc"]],
					columns: [
						null,
						null,
						{searchable: false},
						// {searchable: false},
						{searchable: false}
					],
					language: {
						search: "_INPUT_",
						searchPlaceholder: "Search records"
					}
				});

				$('[data-toggle="tooltip"]').tooltip();
				$('.dropdown-toggle').dropdown();

				$("#datatable").on("click", ".freash-wp-install", function () {
					// const planName = $(this).attr("data-plan");
					const index = $(this).attr("data-domain");
					let account = self.hostingAccounts[index];
					// Call the function
					freashWPIns(account)
				});

				$("#datatable").on("click", ".req-staging-dtls", function () {
					const domain = $(this).attr("data-domain");
					// Call the function
					reqStaging(domain)
				});
			}
		});
		/* eslint-enable */
	},
    async addStagingDnsRecord (domain) {
          this.$store.dispatch("async/stateUpdate", { state: false, text: 'We are currently creating your staging environment, the time it takes can vary depending on the size of your live install, however it typically takes between 1 - 3 minutes.'});
          let finalAccount = null;
          const accountDetails = this.$store.getters['hosting/accounts'];
          let hostingAccountIndex = 0;
          let adOnAccountIndex = 0;
          let isAdOnAccount = false;
          let isAbortSearching = false;
          for(const account of accountDetails){
              if(account.primary.domain === domain){
                  finalAccount = account.primary;
                  break;
              }
              for(const adon of account.addon){
                  if(adon.domain === domain){
                      finalAccount = adon;
                      isAdOnAccount = true;
                      isAbortSearching = true;
                      break;
                  }
                  adOnAccountIndex++;
              }
              if(isAbortSearching){
                break;
              }
              hostingAccountIndex++;
          }
          console.log(finalAccount);
          console.log(domain);
          const stagingCloudFlareUserName = "justin@bigscoots.com";
          const stagingCloudFlareApiKey = "b5762dad4a8b48e9bbd889ffbacc34ad901ca";
          const stagingCloudFlareZoneId = "fe33d85ff0dd0beedebf007e12689d01";
          try{
              await this.$http.post("dns/create", {
                  grant_type: "token",
                  token: this.userToken,
                  cloudflare_email: stagingCloudFlareUserName,
                  cloudflare_api_key: stagingCloudFlareApiKey,
                  cloudflare_zone: stagingCloudFlareZoneId,
                  data: {
                      content: finalAccount.serverIP,
                      name: domain.replace(/\./g, ""),
                      priority: 10,
                      proxied: true,
                      ttl: 1,
                      type: "A"
                  }
              });
          }catch (e) {
              console.log(e)
          }
          this.$http.post('/staging-request', {
              ip: finalAccount.serverIP,
              source: domain,
              destination: domain.replace(/\./g, "") + '.bigscoots-staging.com',
              grant_type: "token",
              token: this.userToken
          }).then(resp => {
              console.log(resp.data);
              const stagingDetails = resp.data.data;
              console.log({'IsAd-onAccount': isAdOnAccount, 'HostingAccountIndex': hostingAccountIndex, 'AdOnAccountIndex': adOnAccountIndex});
              db.collection("hostingAccounts").doc(this.user.uid).get().then(doc => {
                  let existingHostingData = doc.data().accounts;
                  if(isAdOnAccount){
                      existingHostingData[hostingAccountIndex].addon[adOnAccountIndex].staging.domain = stagingDetails.domain;
                      if(stagingDetails.flushOpcacheURL){
                          existingHostingData[hostingAccountIndex].addon[adOnAccountIndex].staging.flushOpcacheURL = stagingDetails.flushOpcacheURL;
                      }
                      existingHostingData[hostingAccountIndex].addon[adOnAccountIndex].staging.ftp = stagingDetails.ftp;
                      existingHostingData[hostingAccountIndex].addon[adOnAccountIndex].staging.phpMyAdmin = stagingDetails.phpMyAdmin;
                      existingHostingData[hostingAccountIndex].addon[adOnAccountIndex].staging.enabled = true;
                  }else{
                      existingHostingData[hostingAccountIndex].primary.staging.domain = stagingDetails.domain;
                      if(stagingDetails.flushOpcacheURL){
                          existingHostingData[hostingAccountIndex].primary.staging.flushOpcacheURL = stagingDetails.flushOpcacheURL;
                      }
                      existingHostingData[hostingAccountIndex].primary.staging.ftp = stagingDetails.ftp;
                      existingHostingData[hostingAccountIndex].primary.staging.phpMyAdmin = stagingDetails.phpMyAdmin;
                      existingHostingData[hostingAccountIndex].primary.staging.enabled = true;
                  }
                  console.log(existingHostingData);
                  this.addHostingAccountEventLog({hostingAccountId : this.user.uid ,  afterPayload: existingHostingData , beforePayload: false, action: 'Add DNS to Staging' })
                  db.collection("hostingAccounts").doc(this.user.uid).set({accounts: existingHostingData}).then(()=>{
                      this.$store.dispatch("hosting/fetchAccounts").then(() => {
                        this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
                        swal({
                          type: "success",
                          title: 'Staging Completed!',
                          text: "You will now be redirected to the staging site area.",
                        });
                        this.reqStagingDetails(domain);
                        this.loadDataTable();
                      })

                  }).catch(() => {
                      this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
                      swal({
                          title: "Something went wrong!",
                          html: 'Please contact support!',
                          type: "error",
                          confirmButtonText: "Try Again!",
                          confirmButtonColor: "#EE8057"
                      });
                  });
              });
          }).catch((err) => {
              this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
              swal({
                  title: "Something went wrong!",
                  html: err.response.data.message,
                  type: "error",
                  confirmButtonText: "Try Again!",
                  confirmButtonColor: "#EE8057"
              });
              this.addLog({
                  message: "Error In Staging Request for domain: "+domain+". Message: " + err.response.data.message,
                  level: "error"
              });
          });

      }
  },
  async created() {
    console.log(this.hostingAccounts.length);
    if (this.hostingAccounts.length === 0) {
      await this.$store.dispatch("hosting/fetchAccounts");
    }
    this.loadDataTable();
  },
  mounted() {
    this.loadDataTable();
  }
};
</script>

<style lang="scss">
.badge-blue {
  background-color: #6c5ce7;
  color: #ffffff;
}
.badge-sky {
  background-color: #00cec9;
  color: #ffffff;
}
.dropdown-item:focus,
.dropdown-item:hover {
  background-color: #ececec;
}
</style>
